import type { BadgeVariant, CartDiscountType } from "@telia/teddy";

/**
 * Maps legacy Styleguide Lozenge status values to Teddy Badge variant values.
 *
 * Mapping (Lozenge → Badge):
 *   default   → special
 *   positive  → success
 *   negative  → error
 *   warning   → warning
 *   communication → special
 *   info      → information
 *   attention → attention
 */
const lozengeStatusMap: Record<string, BadgeVariant> = {
    positive: "success",
    negative: "error",
    warning: "warning",
    communication: "special",
    info: "information",
    attention: "attention",
};

export const mapLozengeStatusToBadgeVariant = (status?: string): BadgeVariant =>
    (status && lozengeStatusMap[status]) || "special";

/**
 * Handles both legacy Styleguide data (with `lozengeStatus`) and already-migrated
 * data (with `badgeVariant`). If `badgeVariant` is already set it is preserved;
 * otherwise `lozengeStatus` is converted via the lozenge→badge mapping.
 */
type CartDiscountTypeInput = CartDiscountType & { lozengeStatus?: string };

export const mapCartDiscountTypes = (types?: CartDiscountTypeInput[]): CartDiscountType[] | undefined => {
    if (!types) return undefined;

    return types.map(({ lozengeStatus, ...rest }) => ({
        ...rest,
        badgeVariant: rest.badgeVariant ?? mapLozengeStatusToBadgeVariant(lozengeStatus),
    }));
};
